<template>
  <div>
    <v-container fluid class="layout-content pa-0 w-full">
      <div class="d-flex align-center">
        <v-spacer></v-spacer>
      </div>
      <div id="agentData">
        <v-card class="text-center pa-0" elevation="0" style="box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2) inset !important">
          <!-- <car-trust-header></car-trust-header> -->
          <v-card-title class="justify-center" style="font-weight: bolder; font-size: xx-large; padding-top: 80px;">แบบฟอร์มให้ความยินยอมในการเก็บรวบรวม ใช้ และเปิดเผยข้อมูลส่วนบุคคล</v-card-title
          >
          <v-card-text class="pa-0">
            <v-row>
              <v-col
                offset-lg="1"
                lg="10"
                offset-md="1"
                md="10"
                offset-sm="1"
                sm="10"
                cols="12"
                :align-self="'center'"
              >
                <v-row dense>
                  <v-col cols="12" :align-self="'center'">
                    <!-- <h3 class="text-start">ข้อมูลรถ</h3> -->
                    <v-container id="carInfo">
                      <v-form
                        ref="form1"
                        v-model="valid1"
                        lazy-validation
                      >
                        <v-row dense>
                          <v-col cols="12" md="6" lg="4">
                            <v-text-field
                              v-model="lead['Customer_Name']['first_name']"
                              label="* ชื่อ"
                              outlined
                              required
                              background-color="#EEF4FF"
                              dense
                              readonly
                              :rules="requiredRules"
                            />
                          </v-col>
                          <v-col cols="12" md="6" lg="4">
                            <v-text-field
                              v-model="lead['Customer_Name']['last_name']"
                              label="* นามสกุล"
                              outlined
                              required
                              background-color="#EEF4FF"
                              dense
                              readonly
                              :rules="requiredRules"
                            />
                          </v-col>
                          <v-col cols="12" md="6" lg="4">
                            <v-text-field
                              v-model="lead['Phone_1']"
                              label="* เบอร์โทรติดต่อ"
                              outlined
                              required
                              background-color="#EEF4FF"
                              dense
                              readonly
                              :rules="requiredRules"
                            />
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-container>
                    <v-row style="place-content: center; padding-top: 50px;">
                      <p style="margin-top: 0px; text-align: -webkit-left; font-weight: bolder; font-size: larger;">การให้ความยินยอมเพื่อวัตถุประสงค์ทางการตลาด
                        การให้ความยินยอมในส่วนนี้จะช่วยให้ท่านได้รับข้อเสนอผลิตภัณฑ์และบริการที่คัดสรรมาสำหรับท่านโดยเฉพาะและตอบโจทย์ความ
                        ต้องการทางการเงินให้กับท่านได้มากยิ่งขึ้น
                      </p>
                    </v-row>
                    <v-row style="place-content: center;">
                      <v-checkbox v-model="allow_submit_1" label="ท่านยินยอมให้บริษัทฯ เก็บรวบรวม ใช้และเปิดเผยข้อมูลส่วนบุคคลของท่าน เพื่อให้ท่านไม่พลาดโอกาสรับข้อเสนอผลิตภัณฑ์และ/หรือบริการ
                        สิทธิพิเศษในการเข้าร่วมกิจกรรมที่บริษัทฯจัดขึ้น รวมถึงข่าวสารคำแนะนำที่เป็นประโยชน์และโปรโมชั่นที่คัดสรรอย่างเหมาะสม
                      " style="margin-top: 0px"></v-checkbox></v-row>
                    <v-row style="place-content: center;">
                      <v-checkbox v-model="allow_submit_2" label="ท่านยินยอมให้บริษัทฯเปิดเผยข้อมูลส่วนบุคคลของท่านให้แก่สถาบันการเงิน หรือบริษัทประกัน ที่เป็นพันธมิตรกับ บริษัทฯเพื่อติดต่อในการนำเสนอผลิตภัณฑ์
                        เพื่อให้ท่านไม่พลาดโอกาสรับข้อเสนอผลิตภัณฑ์หรือบริการ
                        " style="margin-top: 0px"></v-checkbox></v-row>
                    <v-row style="place-content: center; padding-top: 20px;">
                      <v-card class="pa-2" elevation="2" style="width: 320px;">
                        <p>เซ็นยินยอม</p>
                        <div style="display:flex; justify-content:center;">
                          <canvas
                            ref="signatureCanvas"
                            width="300"
                            height="150"
                            style="border: 1px solid #ccc; border-radius: 6px; touch-action: none;"
                            @mousedown="startSigning"
                            @mousemove="drawSignature"
                            @mouseup="stopSigning"
                            @mouseleave="stopSigning"
                            @touchstart.prevent="startSigning"
                            @touchmove.prevent="drawSignature"
                            @touchend.prevent="stopSigning"
                          ></canvas>
                        </div>

                        <v-row class="mt-2" dense>
                          <v-col cols="12">
                            <v-btn
                              color="red"
                              block
                              @click="clearSignature"
                            >
                              ลบลายเซ็น
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-row>
                    <div style="place-content: center; padding-top: 50px;">
                      <v-btn
                        color="#ed8b24"
                        @click.stop="
                          if ($refs['form1'].validate())
                          action();
                        "
                        :disabled="!allow_submit_1 || !allow_submit_2 || !signatureAdded"
                        style="color: white; font-size: medium; font-weight: bold; width: 300px; margin-bottom: 50px;"
                      >
                        ยืนยันข้อมูล
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </div>
      <CallToAction />
    </v-container>
    <v-dialog v-model="policyDialog" persistent width="500">
      <v-card>
        <v-card-title class="white--text primary">
          การยินยอมให้เปิดเผยข้อมูล
        </v-card-title>

        <v-card-text class="pt-2">
          กรุณากดตกลง
          หากท่านอนุญาตให้ทางเจ้าหน้าทีติดต่อกลับและใช้ข้อมูลของท่านเพื่อดำเนินการให้บริการอืนๆที่เกียวข้องกับรีไฟแนนซ์รถยนต์
          <a href="https://devoop.cartrust.co.th/policy" target="_blank">อ่านรายละเอียดเพิ่มเติม</a>
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-btn color="error" text @click="policyDialog = false">
            ยกเลิก
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            :loading="disabled"
            :disabled="disabled"
            @click.stop="action"
          >
            ตกลง
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="successDialog" width="500">
      <v-card>
        <v-card-title class="white--text primary">
          ขอบพระคุณสำหรับข้อมูล
        </v-card-title>

        <v-card-text class="pt-2">
          ทางเราได้รับข้อมูลของท่านเรียบร้อยแล้ว
          และจะมีเจ้าหน้าที่ติดต่อกลับไปภายใน 1 วันทำการ
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click.stop="handleSuccess">
            เสร็จสิ้น
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Snackbar (Visual notification) -->
    <div class="text-center">
      <v-snackbar
        v-model="snackBarAlert.alert"
        :middle="true"
        :color="snackBarAlert.snackBarColor"
        :timeout="snackBarAlert.timeout"
      >
        {{ snackBarAlert.snackBarText }}

        <template v-slot:action="{ attrs }">
          <v-btn
            color="white"
            text
            v-bind="attrs"
            @click="snackBarAlert.alert = false"
          >
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </div>
    <!-- End Snackbar (Visual notification) -->
  </div>
</template>

<script>
import { mapActions } from "vuex";
import CallToAction from '../landing/CallToAction.vue'

export default {
  components: {
    CallToAction
  },
  data: () => {
    return {
      allow_submit_1: false,
      allow_submit_2: false,
      requiredRules: [(v) => !!v || "กรุณากรอกข้อมูล"],
      lengthRule: [(v) => v.length > 0 || "กรุณาเลือก"],
      valid1: false,
      successDialog: false,
      policyDialog: false,
      error: false,
      errorMessages: "",
      disabled: false,
      radios: [],
      showImage: null,
      chosenFile: null,
      options: {
        locale: "en-US",
        prefix: "",
        suffix: "฿",
        length: 11,
        precision: 0,
      },
      options_fix: {
        locale: "en-US",
        prefix: "",
        suffix: "",
        length: 2,
        precision: 0,
      },
      properties: {
        hint: "",
      },
      e1: 1,
      isSigning: false,
      lastX: 0,
      lastY: 0,
      signatureAdded: false,
      snackBarAlert: {
        alert: false,
        snackBarText: "",
        snackBarColor: null,
        timeout: 5000,
      },
      lead: {}
    };
  },
  // computed: {
  //   ...mapGetters("agent", [
  //     "fetchLeadDetailShort"
  //   ]),
  // },
  mounted() {
    this.setupSignatureCanvas();
  },
  created() {
    this.fetchLeadDetailShort({
      'lead_id': this.$route.params.lead_id})
      .then((res) => {
        this.lead = res['lead_information']
      })
  },
  methods: {
    ...mapActions("agent", [
      "fetchLeadDetailShort",
      "updatePDPA"
    ]),
    setupSignatureCanvas() {
      this.$nextTick(() => {
        const canvas = this.$refs.signatureCanvas;
        if (!canvas) return;
        const ctx = canvas.getContext("2d");
        // make it crisp on high-DPI screens
        const ratio = window.devicePixelRatio || 1;
        const cssWidth = 300;
        const cssHeight = 150;
        canvas.width = cssWidth * ratio;
        canvas.height = cssHeight * ratio;
        canvas.style.width = cssWidth + "px";
        canvas.style.height = cssHeight + "px";
        ctx.scale(ratio, ratio);
        ctx.lineCap = "round";
        ctx.lineJoin = "round";
        ctx.strokeStyle = "#000000";
        ctx.lineWidth = 2;
      });
    },

    getCanvasContext() {
      const canvas = this.$refs.signatureCanvas;
      if (!canvas) return null;
      return canvas.getContext("2d");
    },

    getPointerPos(e) {
      const canvas = this.$refs.signatureCanvas;
      const rect = canvas.getBoundingClientRect();
      let clientX, clientY;
      if (e.touches && e.touches.length) {
        clientX = e.touches[0].clientX;
        clientY = e.touches[0].clientY;
      } else {
        clientX = e.clientX;
        clientY = e.clientY;
      }
      return {
        x: clientX - rect.left,
        y: clientY - rect.top
      };
    },

    startSigning(e) {
      this.isSigning = true;
      const pos = this.getPointerPos(e);
      this.lastX = pos.x;
      this.lastY = pos.y;
    },

    drawSignature(e) {
      if (!this.isSigning) return;
      const pos = this.getPointerPos(e);
      const ctx = this.getCanvasContext();
      if (!ctx) return;
      ctx.beginPath();
      ctx.moveTo(this.lastX, this.lastY);
      ctx.lineTo(pos.x, pos.y);
      ctx.stroke();
      this.lastX = pos.x;
      this.lastY = pos.y;

      // keep signature in lead as base64 (updated continually)
      this.lead.signature = this.getSignatureImage();
      this.signatureAdded = true;
    },

    stopSigning() {
      this.isSigning = false;
    },

    clearSignature() {
      const canvas = this.$refs.signatureCanvas;
      if (!canvas) return;
      const ctx = canvas.getContext("2d");
      // clear full canvas (considering internal pixel size)
      ctx.save();
      ctx.setTransform(1, 0, 0, 1, 0, 0); // reset transform
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.restore();
      // re-init styling (because we reset transform)
      this.setupSignatureCanvas();
      this.lead.signature = null;
      this.signatureAdded = false;
    },

    getSignatureImage() {
      const canvas = this.$refs.signatureCanvas;
      if (!canvas) return null;
      // returns PNG base64
      return canvas.toDataURL("image/png");
    },
    action() {
      this.disabled = true;

      // attach signature directly to payload
      if (this.signatureAdded) {
        this.lead.signature = this.getSignatureImage(); // Base64
      }

      this.allow_submit_1 = false;
      this.allow_submit_2 = false;

      this.updatePDPA({
        lead_id: this.$route.params.lead_id,
        first_name: this.lead['Customer_Name']['first_name'],
        last_name: this.lead['Customer_Name']['last_name'],
        Signature_Image: this.getSignatureImage()
      })
        .then((resp) => {
          console.log("Update PDPA response", resp);
          this.policyDialog = false;
          this.successDialog = true;
          this.disabled = false;
          window.location.href =
            "https://m.me/cartrustthailand?ref=FormSubmitted--" +
            resp["lead_id"];

          setTimeout(() => {
            this.$router.go();
          }, 5000);
        })
        .catch((err) => {
          this.allow_submit_1 = true;
          this.allow_submit_2 = true;
          this.disabled = false;
          console.log("Update PDPA err", err);
          this.snackBarAlert.alert = true;
          this.snackBarAlert.snackBarText = err.response?.data?.response?.detail || "เกิดข้อผิดพลาด";
          this.snackBarAlert.snackBarColor = "error";
          this.snackBarAlert.timeout = 3000;
        });

      setTimeout(() => {
        this.disabled = false;
      }, 10000);
    },
    handleSuccess() {
      this.successDialog = false;
      this.$router.push("/lead");
    }
  }
};
</script>

<style>
.price_text {
  font-size: 40px;
  line-height: 26pt;
}
.my-iframe-container {
  overflow: hidden;
  height: 19660px;
}
.iframe {
  position: relative;
  top: -540px;
  left: 0px;
  bottom: -540px;
  width: 100%;
  height: 20200px;
}
</style>

